// extracted by mini-css-extract-plugin
export var gif = "_hu-0";